import {
  SEARCH_TEMPLATE,
  SEARCH_TEMPLATE_SUCCESS,
  SEARCH_TEMPLATE_FAILED,
  SAVE_TEMPLATE_FAILED,
  SAVE_TEMPLATE_SUCCESS,
  FETCH_OFFICES_SUCCESS,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_TEMPLATE_PATTERNS_SUCCESS,
  FETCH_CURRENT_TEMPLATE_PATTERN_SUCCESS,
  FETCH_CURRENT_PATTERN_SUCCESS,
  FETCH_RCD_LOCATION_NUMBER_SUCCESS,
  FETCH_CHANGE_RESULTS_SUCCESS,
} from './actions';

type TState = {
  requests: [];
  loading: boolean;
  error: any;
  offices: any[];
  employees: any[];
  currentTemplatePattern: any;
  saveLoading: boolean;
  saveAccommodationSuccess: any;
};

const initialState: TState = {
  requests: [],
  loading: false,
  error: null,
  offices: [],
  employees: [],
  currentTemplatePattern: null,
  saveLoading: false,
  saveAccommodationSuccess: null,
};

export const templateAccomodationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_TEMPLATE:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: payload,
      };
    case SEARCH_TEMPLATE_FAILED:
      return {
        ...state,
        sorting: payload,
      };
    case SAVE_TEMPLATE_SUCCESS:
      return {
        ...state,
        saveLoading: false,
        saveAccommodationSuccess: true,
      };
    case SAVE_TEMPLATE_FAILED:
      return {
        ...state,
        saveLoading: false,
        saveAccommodationSuccess: false,
        saveAccommodationFailureMssg: payload,
      };
    case FETCH_OFFICES_SUCCESS:
      return {
        ...state,
        offices: payload,
      };
    case FETCH_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: payload,
      };
    case FETCH_TEMPLATE_PATTERNS_SUCCESS:
      return {
        ...state,
        templatePatterns: payload,
      };
    case FETCH_CURRENT_TEMPLATE_PATTERN_SUCCESS:
    case FETCH_CURRENT_PATTERN_SUCCESS:
      return {
        ...state,
        currentTemplatePattern: payload,
      };
    case FETCH_CHANGE_RESULTS_SUCCESS:
      return {
        ...state,
        changeResults: payload,
      };

    case FETCH_RCD_LOCATION_NUMBER_SUCCESS:
      return {
        ...state,
        rcd: payload,
      };
    case 'TEMPLATE_ACCOMODATION_RESET_SAVE_SUCCESS':
      return {
        ...state,
        saveAccommodationSuccess: false,
        saveAccommodationFailureMssg: { error: { messages: [] } },
      };
    default:
      return state;
  }
};
